define(
({
  "select_shipping_method": "Selecionar método de envio"
})
);
